<ion-header>
  <ion-toolbar>
    <ion-title>Pago con tarjeta</ion-title>
    <ion-buttons slot="start">
      <ion-back-button
        defaultHref="/tecservice-transportec/wallet/balance/payment-method"
        color="primary"
      ></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">
    <ion-card>
      <ion-card-header>
        <ion-card-title>
          <ion-img src="/assets/imgs/openpay-color.png" class="ion-padding"></ion-img>
        </ion-card-title>
        <ion-card-subtitle>Datos de tarjeta</ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        <ion-item>
          <ion-label position="stacked">Nombre completo*</ion-label>
          <ion-input type="text" placeholder="Ej. Manuel López Hernández" formControlName="fullname"></ion-input>
        </ion-item>
        <p
          *ngIf="form.controls['fullname'].errors && (form.controls['fullname'].dirty || form.controls['fullname'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-item>
          <ion-label position="stacked">Número de tarjeta*</ion-label>
          <ion-input
            id="cc"
            #cc
            formControlName="creditCard"
            placeholder="1234 5678 9012 3456"
            type="tel"
            autocomplete="cc-number"
            ccNumber
            (ionChange)="ccTypeCheck($event)"
          ></ion-input>
          <ion-icon src="/assets/icon/mastercard.svg" slot="end" *ngIf="ccType === 'mastercard'"></ion-icon>
          <ion-icon src="/assets/icon/visa.svg" slot="end" *ngIf="ccType === 'visa'"></ion-icon>
          <ion-icon src="/assets/icon/amex.svg" slot="end" *ngIf="ccType === 'amex'"></ion-icon>
        </ion-item>
        <p
          *ngIf="form.controls['creditCard'].errors && (form.controls['creditCard'].dirty || form.controls['creditCard'].touched)"
          class="danger ion-padding"
        >
          Inválido.
        </p>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">Expira*</ion-label>
              <ion-input
                id="cc-exp-date"
                formControlName="expirationDate"
                placeholder="12/26"
                type="tel"
                autocomplete="cc-exp"
                ccExp
              ></ion-input>
            </ion-item>
            <p
              *ngIf="form.controls['expirationDate'].errors && (form.controls['expirationDate'].dirty || form.controls['expirationDate'].touched)"
              class="danger ion-padding"
            >
              Inválido.
            </p>
          </ion-col>
          <ion-col>
            <ion-item>
              <ion-label position="stacked">CVC*</ion-label>
              <ion-input
                id="cc-cvc"
                formControlName="cvc"
                placeholder="123"
                type="tel"
                autocomplete="off"
                ccCVC
              ></ion-input>
            </ion-item>
            <p
              *ngIf="form.controls['cvc'].errors && (form.controls['cvc'].dirty || form.controls['cvc'].touched)"
              class="danger ion-padding"
            >
              Inválido.
            </p>
          </ion-col>
        </ion-row>
      </ion-card-content>
    </ion-card>
    <div>
      <ion-button shape="round" type="submit" [disabled]="form.invalid" expand="block">Pagar</ion-button>
    </div>
  </form>
</ion-content>
